interface AppConfig {
  [key: string]: never;
}

declare global {
  interface Window {
    APP_CONFIG: AppConfig;
  }
}

export const appConfig: AppConfig = window.APP_CONFIG || {};
